import { useState } from 'react'
import Modal from '@material-ui/core/Modal'
import { Formik } from 'formik'
import { connect } from 'react-redux'
import * as Yup from 'yup'
import { Box, TextField, Typography } from '@material-ui/core'
import axios from 'axios'
import urlStrings from '../../utils/urlStrings'
import FilledButton from '../FilledButton'
import history from '../../routes/history'
import { getSessionToken } from '../../utils/helper'
import {applicationService} from '../../Services/ApplicationService'
import { useStyles } from './styles'

const RejectReasonPopUp = (props) => {
  const classes = useStyles()
  const { setReject, setRejected, currentSiteID, setLoading, getSites } = props

  const initialValues = {
    reason: '',
  }
  const validationSchema = Yup.object({
    reason: Yup.string().required('*required'),
  })
  const reactOnSubmit =  (formik) => {
    setRejected(true)
    setReject(false)
    setOpen(false)
    setLoading(true)
applicationService.rejectApplicationBySiteId(currentSiteID,formik.values.reason)
      .then((success) => {
        getSites()
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
        getSites()
        if (String(error).search(401) !== -1) history.push('/')
      })
  }
  const [open, setOpen] = useState(true)
  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={reactOnSubmit}
      >
        {(formik) => (
          <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={open}
          >
            <div className={classes.paper}>
              <Box className={classes.header}>
                <Typography className={classes.text}>
                  Please provide a reason for rejection
                </Typography>
                <Typography className={classes.text}>below.</Typography>
              </Box>
              <TextField
                className={classes.reasonbox}
                classes={{ root: classes.root }}
                variant="outlined"
                multiline
                name="reason"
                rows={6}
                onChange={(event) => {
                  formik.setFieldValue('reason', event.target.value)
                }}
                // maxRows={8}
              ></TextField>
              <Box className={classes.options}>
                <FilledButton
                  label="Submit"
                  width="120px"
                  height="36px"
                  disabled={formik.values.reason === '' ? true : false}
                  primary={true}
                  onClick={() => {
                    reactOnSubmit(formik)
                  }}
                ></FilledButton>
                <FilledButton
                  label="Cancel"
                  width="120px"
                  height="36px"
                  primary={false}
                  tertiary={true}
                  onClick={() => {
                    setRejected(false)
                    setReject(false)
                    setOpen(false)
                  }}
                ></FilledButton>
              </Box>
            </div>
          </Modal>
        )}
      </Formik>
    </div>
  )
}

const mapStateToProps = ({ applications }) => {
  const { currentSiteID } = applications
  return { currentSiteID }
}
export default connect(mapStateToProps, null)(RejectReasonPopUp)
